import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面不存在 - 404 | 剧焰短剧",
    description: "你访问的页面不存在或已被移除，返回剧焰短剧首页继续观看热门微短剧。",
    keywords: "404,页面不存在,剧焰短剧",
    path: location.pathname,
  });

  return (
    <>
      <SiteHeader />
      <main className="flex min-h-[70vh] w-full flex-col items-center justify-center px-4 text-center">
        <p className="font-heading text-7xl font-black text-gradient-gold md:text-9xl">404</p>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-50 md:text-3xl">这一集走丢了</h1>
        <p className="mt-2 max-w-md text-xs text-foreground-500 md:text-sm">
          你访问的地址不存在或剧集已下架。回到首页，继续追那些还没看完的爆款短剧吧。
        </p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-bold text-background-950 transition-colors hover:bg-primary-400"
          >
            返回首页
          </Link>
          <Link
            to="/category"
            className="cursor-pointer whitespace-nowrap rounded-full border border-foreground-50/15 px-6 py-2.5 text-sm text-foreground-200 transition-colors hover:border-primary-400/60 hover:text-primary-300"
          >
            浏览全部短剧
          </Link>
        </div>
      </main>
      <SiteFooter />
    </>
  );
}